import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { CategoryCardV1 } from '../CompanyEvents/EventLibrary/style';
import { EventPointsWrapper } from '../MainEvents/styles';
import { withTranslation } from 'react-i18next';
import CreateChallengePoup from './challengeCreatePopup';
import LazyImage from './../common/LazyImage/LazyImage';
import { ImageUrl } from '../../utils/constants';

// pillar_id → { bg, border } color map
const pillarColorMap = {
  1:  { bg: '#FCF2F3', border: '#EEB3B4' }, // Physical
  6:  { bg: '#FCF2F3', border: '#EEB3B4' }, // Occupational
  3:  { bg: '#FCF7F0', border: '#EED5BA' }, // Emotional
  8:  { bg: '#FCF7F0', border: '#EED5BA' }, // Environmental
  11: { bg: '#F1F8F2', border: '#BDDDC2' }, // Nutritional
  12: { bg: '#F1F8F2', border: '#BDDDC2' }, // Financial
  4:  { bg: '#F5F6E8', border: '#CFCF96' }, // Social
  9:  { bg: '#F5F6E8', border: '#CFCF96' }, // Purpose & Contribution
  2:  { bg: '#F2F5FB', border: '#D3DEF2' }, // Mental
  7:  { bg: '#F2F5FB', border: '#D3DEF2' }, // Spiritual
  5:  { bg: '#FAF5F8', border: '#E1C0D1' }, // Intellectual
  10: { bg: '#FAF5F8', border: '#E1C0D1' }, // Longevity
};

class BehaviorCategory extends Component {

  resolveIconAndColor = (category) => {
    const rawIcon = category?.icon ?? '';
    const rawNewIcon = category?.new_icon ?? '';
    const rawImage = category?.image ?? '';
    const pillarId = category?.pillar_id;

    const colors = pillarColorMap[pillarId] || { bg: '#FFFFFF', border: '#DCDCDC' };
    const fallbackIconUrl = rawIcon || rawNewIcon || rawImage || null;

    return { bgColor: colors.bg, borderColor: colors.border, fallbackIconUrl };
  };

  // handleCategoryClick = (category) => {
  //   const { history } = this.props;
  //   const categoryName = category.category_name === "medical" ? "health" : category.category_name;

  //   if (history?.location?.pathname === "/challenges/categories") {
  //     history.push({
  //       pathname: `/challenges/behavior-categories/${categoryName}`,
  //       state: { name: category.name }
  //     });
  //   } else {
  //     history.push({
  //       pathname: `/company/challenges/behavior-categories/${categoryName}`,
  //       state: { name: category.name }
  //     });
  //   }
  // };



  handleCategoryClick = (category) => {
    window.console.log("Clicked category --- ", category);
    const { history } = this.props;
    history.push({ pathname: `/company/challenges/legacy-challenge-category/${category?.id}`, state: { categoryData: category } });
  };




  render() {
    const { wellbeingCategoriesData, t } = this.props;

    return (
      <EventPointsWrapper margin gap={'12px 8px'}>
        {Array.isArray(wellbeingCategoriesData) && wellbeingCategoriesData.length > 0 &&
          wellbeingCategoriesData.map((category, index) => {
            const { bgColor, borderColor, fallbackIconUrl } =
              this.resolveIconAndColor(category);

            return (
              <CategoryCardV1
                key={index}
                isCardRadius={'12px'}
                cardHeight='72px'
                cardPadding={'12px 8px'}
                background={bgColor}
                style={{
                  border: `0.75px solid #DCDCDC`,
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                }}
                onClick={() => this.handleCategoryClick(category)}
              >
                <div
                  className="icon"
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    border: `1px solid ${borderColor}`,
                    borderRadius: '50%',
                    padding: '4px',
                  }}
                >
                  {fallbackIconUrl ? (
                    <LazyImage
                      // div={'icon'}
                      src={/^https?:\/\//i.test(fallbackIconUrl)
                        ? fallbackIconUrl
                        : `${ImageUrl}/${fallbackIconUrl}`}
                    />
                  ) : (
                    <div
                      style={{
                        width: 36,
                        height: 36,
                        borderRadius: 6,
                        background: '#EAEAEA'
                      }}
                    />
                  )}
                </div>

                <div style={{ marginLeft: 12, flex: 1 }}>
                  <div className="name" title={t(category?.category_name)}>
                    {t(category?.category_name)}
                  </div>
                  <div
                    className="challengeCount"
                    style={{
                      fontSize: '12px',
                      fontWeight: '400',
                      color: '#666',
                      lineHeight: '16px',
                      marginTop: '2px'
                    }}
                  >
                    {t(category.count)}
                  </div>
                </div>
              </CategoryCardV1>
            );
          })
        }

        <CreateChallengePoup />
      </EventPointsWrapper>
    );
  }
}

BehaviorCategory.propTypes = {
  history: PropTypes.object,
  wellbeingCategoriesData: PropTypes.array,
  t: PropTypes.func
};

export default withTranslation()(BehaviorCategory);
